<script setup>
import { ref, onUnmounted } from "vue";
import eventBus from "../utils/eventBus";
// 定义props
const props = defineProps({
  // 传入子内容
  content: {
    type: String,
    default: "",
  },
  // 是否可编辑
  editable: {
    type: Boolean,
    default: false,
  },
  // 内容ID
  contentId: {
    type: String,
    default: "",
  },
  // 是否显示删除按钮
  showDelete: {
    type: Boolean,
    default: false,
  },
  // 是否显示序号
  showOrderNum: {
    type: Boolean,
    default: false,
  },
});

// 定义emits
const emit = defineEmits(["edit", "delete", "order"]);

// 控制遮罩显示状态
const isHovered = ref(false);

// 处理鼠标移入
const handleMouseEnter = () => {
  // 当可编辑时显示编辑按钮
  if (props.editable) {
    isHovered.value = true;
    //触发父组件的mouseleave事件
    // 发布编辑事件到EventBus
    // eventBus.emit('handleMouseEnter', props.contentId);
    // window._duilie.push(props.contentId)
  }
};

// 处理鼠标移出
const handleMouseLeave = () => {
  isHovered.value = false;
  // window._duilie.pop()
  // eventBus.emit('handleMouseEnter', window._duilie[window._duilie.length - 1]);
};

// 处理编辑按钮点击
const handleEditClick = (event) => {
  // 阻止事件冒泡
  event.stopPropagation();
  // 触发编辑事件
  emit("edit");
};
// 处理编辑按钮点击
const handleOrderClick = (event) => {
  // 阻止事件冒泡
  event.stopPropagation();
  // 触发编辑事件
  emit("order",event);
};


// 处理删除按钮点击
const handleDeleteClick = (event) => {
  // 阻止事件冒泡
  event.stopPropagation();
  // 触发删除事件
  emit("delete");
};

// 订阅文本更新事件
eventBus.on("handleMouseEnter", (data) => {
  console.log(data);
  // 只有当更新的数据与当前组件ID匹配时才更新
  if (data !== props.contentId) {
    isHovered.value = false;
  } else {
    if (props.editable) {
      isHovered.value = true;
    }
  }
});

// 组件卸载时取消订阅

// 暴露方法给父组件
defineExpose({
  // 当子组件需要隐藏父组件编辑按钮时调用
  hideEditButton: () => {
    // isHovered.value = false
  },
});
</script>

<template>
  <div
    class="hover-mask-container"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <!-- 内容区域 -->
    <div class="content-area">
      <slot v-if="content === ''"></slot>
      <template v-else v-html="content"></template>
    </div>

    <!-- 遮罩和编辑按钮 -->
    <div v-if="(editable || showDelete || showOrderNum) && isHovered" class="mask-overlay">
      <el-icon
        class="order-number"
        color="#222"
        size="20"
        @click="handleOrderClick"
        v-if="showOrderNum"
      >
        <DCaret />
      </el-icon>
      <el-icon
        class="edit-button"
        color="#fff"
        size="20"
        @click="handleEditClick"
        v-if="editable"
      >
        <Edit />
      </el-icon>
      <el-icon
        color="#f56c6c"
        size="20"
        class="delete-button"
        @click="handleDeleteClick"
        v-if="showDelete"
      >
        <Delete />
      </el-icon>
    </div>
  </div>
</template>

<style scoped>
.hover-mask-container {
  position: relative;
  display: inline-block;
  /* overflow: hidden; */
  /* cursor: pointer; */
  /* 默认为相对定位元素提供最小尺寸 */
  min-width: 90px;
  /* min-height: 3rem; */
  /* min-height: 200px; */
}

.content-area {
  width: 100%;
  height: 100%;
}

.mask-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  /* padding: 8px; */
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  transition: opacity 1s ease-in-out;
  opacity: 0;
  /* z-index: 1000; */
}

.mask-overlay:not([style*="display: none"]) {
  opacity: 1;
}

.edit-button {
  background-color: #66b1ff;
  color: white;
  border: none;
  padding: 2px 2px;
  border-radius: 4px;
  cursor: pointer;
  /* font-size: 14px; */
  transition: all 0.3s ease;
  z-index: 1000;
}
.edit-button + .delete-button {
  margin-left: 8px;
}

.edit-button:hover {
  background-color: #66b1ff;
  transform: scale(1.05);
}

.delete-button {
  /* background-color: #f56c6c; */
  color: white;
  border: none;
  padding: 2px;
  /* padding: 8px 16px; */
  border-radius: 4px;
  cursor: pointer;
  /* font-size: 14px; */
  transition: all 0.3s ease;
  z-index: 1000;
  background-color: #f78989;
}

.delete-button:hover {
  background-color: #f78989;
  color: white;
  transform: scale(1.05);
}

.order-number {
   border: none;
  padding: 2px;
  /* padding: 8px 16px; */
  border-radius: 4px;
  cursor: pointer;
  /* font-size: 14px; */
  transition: all 0.3s ease;
  z-index: 1000;
  margin-right: 8px;
  background-color: #fff;
}
.order-number:hover {
  background-color: #fff;
  transform: scale(1.05);
}
</style>
